import { useAtom } from 'jotai'
import { useScopes } from '~/api/api.hook'
import { useToast } from '~/components/Toast/useToasts'
import { currentScopeState } from '~/state'
import { PureSettingsSecurityPage } from './PureSettingsSecurityPage'

export const SettingsSecurityPage = () => {
  const [currentScope, setCurrentScope] = useAtom(currentScopeState)
  const { byId } = useScopes(null)
  const toast = useToast()
  const onActivateMfa = async () => {
    try {
      await byId.put({ ...currentScope, mfaRequired: true })
      setCurrentScope((scope) => ({ ...scope, mfaRequired: true }))
      toast.success('MFA has been activated for all users in this account.')
    } catch (_e) {
      toast.alert(`Something went wrong when trying to activate MFA`)
    }
  }

  return <PureSettingsSecurityPage scope={currentScope} onActivateMfa={onActivateMfa} />
}
